import { GOOGLE_MAPS_SUGGESTION_TYPES } from '../utils/mapUtils';
import Rest from '../rest';

class SearchAutocompleteService {
  constructor() {
    window.googleMapsApiLoader
      .importLibrary('places')
      .then(({ AutocompleteService }) => {
        this._placesService = new AutocompleteService();
      })
      .catch((error) => {
        console.error(`Failed to import Places library from Google Maps API: ${error}`);
      });
  }

  findPlaces = (input, country) => {
    return new Promise((resolve, reject) => {
      if (input) {
        const req = {
          input: input,
          componentRestrictions: {
            country: country
          },
          types: GOOGLE_MAPS_SUGGESTION_TYPES
        };

        this._placesService.getPlacePredictions(req, (predictions, status) => {
          switch (status) {
            case 'OK':
              resolve(predictions);
              break;
            case 'ZERO_RESULTS':
              resolve([]);
              break;
            default:
              reject(new Error('An unexpected error occurred with retrieving suggestions.'));
          }
        });
      }
      else {
        reject(new Error('Input is required.'));
      }
    });
  };

  getAzureCognitiveSearchSuggestions = (payload) => {
    return new Promise((resolve, reject) => {
      if (payload) {
        const url = `${process.env.LOCATOR_API}/Practice/searchSuggestions`;

        Rest.post(url, payload, { timeout: process.env.LOCATOR_API_TIMEOUT })
          .then(res => resolve(res?.data))
          .catch(error => reject(error));
      }
      else {
        reject(new Error('Input is required.'));
      }
    });
  };

  getAzureCognitiveSearchSuggestionByAddress = (payload) => {
    return new Promise((resolve, reject) => {
      if (payload) {
        const url = `${process.env.LOCATOR_API}/Practice/searchSuggestionsByAddress`;

        Rest.post(url, payload, { timeout: process.env.LOCATOR_API_TIMEOUT })
          .then(res => resolve(res?.data))
          .catch(error => reject(error));
      }
      else {
        reject(new Error('Input is required.'));
      }
    });
  }

  getAzureCognitiveSearchSuggestionByChain = (payload) => {
    return new Promise((resolve, reject) => {
      if (payload) {
        const url = `${process.env.LOCATOR_API}/Practice/searchSuggestionsByChain`;

        Rest.post(url, payload, { timeout: process.env.LOCATOR_API_TIMEOUT })
          .then(res => resolve(res?.data))
          .catch(error => reject(error));
      }
      else {
        reject(new Error('Input is required.'));
      }
    });
  }
}

export default SearchAutocompleteService;
